var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedfilter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.999999C0 0.44772 0.447715 0 0.999999 0H19C19.5523 0 20 0.44772 20 0.999999C20 1.55228 19.5523 2 19 2H0.999999C0.447716 2 0 1.55228 0 0.999999Z",
    fill: "#BF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6C3 5.44772 3.44772 5 4 5H16C16.5523 5 17 5.44772 17 6C17 6.5523 16.5523 7 16 7H4C3.44772 7 3 6.5523 3 6Z",
    fill: "#BF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12H12C12.5523 12 13 11.5523 13 11C13 10.4477 12.5523 10 12 10H8Z",
    fill: "#BF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedfilter);
export default __webpack_public_path__ + "static/media/redfilter.6f937a765d1b9754a28dcedd613cb3c5.svg";
export { ForwardRef as ReactComponent };